export default __webpack_public_path__ + "static/media/avatar_mice9.90863685.mp3";